// Adds single-open-at-a-time grouping on top of the shared accordion.js,
// without modifying it (accordion.js is reused by faq-accordion.liquid,
// salon-treatment-faq.liquid, and regimen-faq.liquid — this file must never
// change behavior for those). A single delegated listener on `document`
// always fires after accordion.js's own per-trigger listener, because
// target-phase listeners run before the event bubbles to an ancestor —
// so by the time this handler runs, the clicked trigger's aria-expanded
// already reflects the click accordion.js just processed.
//
// Each investor-toc topic lives in its own physical Shopify section (not
// nested blocks of one shared section), so there is no single DOM ancestor
// to scope a `.closest('.investor-toc')` group query to — the group is
// page-wide by construction. `closest()` is still used as a cheap guard so
// clicks on unrelated accordion.liquid consumers (FAQ sections) bail out
// before the page-wide query runs; the actual "other rows to close" lookup
// queries the whole document for any element carrying the shared
// `.investor-toc` marker class, which every investor-toc-* section's row
// wrapper carries regardless of which of the many separate sections it's in.
if (!document.documentElement.dataset.investorTocBound) {
  document.documentElement.dataset.investorTocBound = 'true';

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-accordion-trigger]');
    if (!trigger) return;

    if (!trigger.closest('.investor-toc')) return;

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (!isOpen) return;

    const otherOpenTriggers = document.querySelectorAll(
      '.investor-toc [data-accordion-trigger][aria-expanded="true"]',
    );

    for (const otherTrigger of otherOpenTriggers) {
      if (otherTrigger !== trigger) {
        otherTrigger.click();
      }
    }
  });
}
